import _ from 'lodash';
const initialState ={
  auditorList:[],
  supervisor:[],
  mappedAgentList:[]
}

export default (state = initialState, action) => {
  switch (action.type) {   
   case "AUDITOR_LIST":
    let data  = [];
    if(!_.isEmpty(action.auditorList)){
      let obj = _.uniqBy(action.auditorList, 'employeeId')
      _.map(obj, (obj) =>{
        data.push({'firstName':obj.firstName,'employeeId':obj.employeeId,
        'userInventoryMaps':obj.userInventoryMaps})
      })
    }
    return Object.assign({}, state, {
      auditorList: data,
      isPending:action.isPending
    })
  case "AGENT_LIST_SEARCH":
    return Object.assign({}, state, {
      agentList: action.agentList
    })
  case "MAPPED_AGENT_LIST_VIEW":
    return Object.assign({}, state, {
      mappedAgentList: action.mappedAgentList,
      isPending:action.isPending
    })
  case "SUPERVISOR_LIST_SEARCH":
    return Object.assign({}, state, {
      supervisor: action.supervisor
    })
  case "IS_PENDING":
    return Object.assign({}, state, {
      isPending:action.isPending
    })
  case "AGENT_LIST_SEARCH_ERROR":
    return Object.assign({}, state, {
      showerror: action.showerror,
      errmessage: action.errmessage,
      isPending:action.isPending
    })
  case "AGENT_ACTION_MODAL_CLOSE":
    return Object.assign({}, state, {
      showerror: action.showerror
    })
   default:
    return state
  }
 }